import { IconButton, Tooltip } from "@material-ui/core";
import { AddCircleOutline } from "@material-ui/icons";
import React, { memo, useEffect } from "react";
import { observer } from "mobx-react";
import CommonButton from 'app/common/Component/Button/CommonButton';

const HandleKeydown = ({
    title, handlePush,
    keyName = "F1", icon, tooltip = "Thêm mới",
    disabled, className, fullWidth
}) => {
    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === keyName && !disabled) {
                event.preventDefault();
                handlePush();
            }
        };

        window.addEventListener('keydown', handleKeyDown);
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [keyName, handlePush]);

    return (
        <Tooltip title={`${tooltip ? tooltip + "." : ""} Ấn ${keyName} để thao tác nhanh`}>
            <>
                {title && title !== "" ?
                    <CommonButton fullWidth={fullWidth} disabled={disabled} onClick={handlePush} className={className}>
                        {title}
                    </CommonButton> :
                    <IconButton disabled={disabled}
                        size="small" onClick={handlePush} className={`btn-orange ${className}`}>
                        {icon || <AddCircleOutline />}
                    </IconButton>
                }
            </>
        </Tooltip>
    );
};

export default memo(observer(HandleKeydown))